module.exports = __webpack_public_path__ + "img/202405_08_sp.8d1b3247.jpg";